﻿import { getFormData, getValidationConstraints, showValidationErrors, clearValidationErrors } from './utils';
import validate from 'validate.js';

const form = document.getElementById('login-form');
const constraints = getValidationConstraints(form);

form.addEventListener('submit', function (e) {
	e.preventDefault();
	const errors = validate(getFormData(form), constraints);
	if (errors == null)
		form.submit();
	else
		showValidationErrors(form, errors);
});
for (let input of form.querySelectorAll('input, textarea, select')) {
	input.addEventListener('change', () => {
		const errors = validate(getFormData(form), constraints);
		if (errors == null)
			clearValidationErrors(form);
		else
			showValidationErrors(form, errors);
	});
}
